import React from 'react';
import { ILabelProps } from './Label.types';
import styles from './Label.module.css';

const Label: React.FC<ILabelProps> = ({ text, className = styles.scoreTitle }) => {
  return <div className={className}>{text}</div>;
};

export default React.memo(Label);
